export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const sumArraysItemWise = (arrays) => arrays[0].map((_, i) => arrays.reduce((sum, arr) => sum + arr[i], 0));

export const getQueryParam = (url, param) => {
  const params = url.split("?")[1];
  const urlSearchParams = new URLSearchParams(params);
  return urlSearchParams.get(param);
};

export const titleize = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Only lowercase geographic codes are safe to upcase; PG&E territories and 3CE tiers
// already carry their own case. See the stream-key families in CLAUDE.md.
export const formatLocation = (location) =>
  location && location === location.toLowerCase() ? location.toUpperCase() : location;

const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 10,
});

const CURRENCY_FORMATTER_ROUNDED = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const formatDollars = (amount) => {
  return CURRENCY_FORMATTER.format(amount);
};

export const formatDollarsRounded = (amount) => {
  return CURRENCY_FORMATTER_ROUNDED.format(amount);
};

const dateTimeOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
  timeZoneName: undefined,
};

export const formatDateTime = (date) => new Intl.DateTimeFormat("en-US", dateTimeOptions).format(date);

export const noop = () => {
  return null;
};
